module.exports = __webpack_public_path__ + "img/headshot.03f5fe9c.png";